import { useConst } from "@chakra-ui/react";
import { AsyncReturnType } from "type-fest";

import { ReportService } from "@/services";
import { UseQuerySimpleOptions, useQuery } from "@/services/hooks";
import { gen } from "@/utils";

type QueryArgs = Parameters<typeof ReportService.getRespondedReport>[0];
type QueryFnData = AsyncReturnType<typeof ReportService.getRespondedReport>;
type Error = unknown;

const queryKey = (args: QueryArgs) => ["reports", "responded", args];

export const useRespondedReport = <TData = QueryFnData>(
  args: QueryArgs,
  options?: UseQuerySimpleOptions<QueryFnData, Error, TData>
) => {
  const response = useQuery<QueryFnData, Error, TData>(
    queryKey(args),
    () => ReportService.getRespondedReport(args),
    {
      skeletonData: useConst({ report: gen.reports() }),
      ...options,
    }
  );

  return response;
};

useRespondedReport.queryKey = queryKey;
